import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { CHANNELS } from '@spotahome/ui-library';
import ListingChipsList from '@spotahome/ui-library/src/tenant/components/ListingChipsList';

const openContractBasicsSimplifiedModal = ({
  chips = [],
  documentsAdditionalInfo = null,
  fullscreenOnMobile = false
} = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('listing.simplification.bottom.contract-basics.card.title'),
    body: (
      <>
        <ListingChipsList chipList={chips} />
        {documentsAdditionalInfo && (
          <p className="property-rules-redesign__documents-policy-additional-info">
            <strong>
              {trans('property.rule.documentsPolicy.otherDocuments')}
            </strong>{' '}
            {documentsAdditionalInfo}
          </p>
        )}
      </>
    ),
    fullscreenOnMobile
  });
};

export default openContractBasicsSimplifiedModal;
